import { render, staticRenderFns } from "./workcenter-column.vue?vue&type=template&id=09711366"
import script from "./workcenter-column.vue?vue&type=script&lang=js"
export * from "./workcenter-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports